import { render } from "./IncomesBySource.vue?vue&type=template&id=bdd52822&scoped=true"
import script from "./IncomesBySource.vue?vue&type=script&lang=js"
export * from "./IncomesBySource.vue?vue&type=script&lang=js"

import "./IncomesBySource.vue?vue&type=style&index=0&id=bdd52822&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd52822"]])

export default __exports__